import React from 'react';
import { Helmet } from 'react-helmet-async';

const TermsConditions = () => {
  return (
    <>
      <Helmet>
        <title>Terms & Conditions - Trademark Texticon | Service Agreement & Legal Terms</title>
        <meta name="description" content="Review Trademark Texticon's terms and conditions. Understand our service agreement, fees, client responsibilities, and legal terms for trademark registration services." />
        <meta name="keywords" content="terms and conditions, service agreement, trademark registration terms, legal agreement, USPTO filing terms" />
      </Helmet>
      
      <div className="legal-page">
        <div className="legal-container">
          <h1>Terms & Conditions</h1>
          <p className="legal-updated">Last Updated: December 2024</p>
          
          <section>
            <h2>1. Agreement to Terms</h2>
            <p>By accessing and using Trademark Texticon's services, you agree to be bound by these Terms and Conditions and all applicable laws and regulations.</p>
          </section>

          <section>
            <h2>2. Services</h2>
            <p>Trademark Texticon provides trademark registration services, including trademark searches, USPTO filing, and related legal services. We do not guarantee approval of your trademark application by the USPTO.</p>
          </section>

          <section>
            <h2>3. Fees and Payments</h2>
            <p>Service fees are as listed on our pricing page. Government filing fees are separate and paid directly to the USPTO. All fees are non-refundable unless otherwise specified.</p>
          </section>

          <section>
            <h2>4. Client Responsibilities</h2>
            <p>Clients must provide accurate information, respond to our communications in a timely manner, and comply with USPTO requirements and deadlines.</p>
          </section>

          <section>
            <h2>5. Limitation of Liability</h2>
            <p>Trademark Texticon is not liable for USPTO decisions, delays in processing, or outcomes of trademark applications. Our liability is limited to the fees paid for our services.</p>
          </section>

          <section>
            <h2>6. Intellectual Property</h2>
            <p>All content on this website, including text, graphics, logos, and software, is the property of Trademark Texticon and protected by copyright laws.</p>
          </section>

          <section>
            <h2>7. Governing Law</h2>
            <p>These terms are governed by the laws of the State of California, United States.</p>
          </section>

          <section>
            <h2>8. Contact Information</h2>
            <p>For questions about these Terms, contact us at info@trademarktexticon.com or +1 (123) 123-4567.</p>
          </section>
        </div>
      </div>
    </>
  );
};

export default TermsConditions;
